import React, { useEffect, useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import { Box } from '@material-ui/core';
import GridContainer from '../../../../@jumbo/components/GridContainer';
import Grid from '@material-ui/core/Grid';
import AppTextInput from '../../../../@jumbo/components/Common/formElements/AppTextInput';
import CmtAvatar from '../../../../@coremat/CmtAvatar';
import { useDropzone } from 'react-dropzone';
import Button from '@material-ui/core/Button';
import CmtList from '../../../../@coremat/CmtList';
import IconButton from '@material-ui/core/IconButton';
import AppSelectBox from '../../../../@jumbo/components/Common/formElements/AppSelectBox';
import { emailNotValid, requiredMessage } from '../../../../@jumbo/constants/ErrorMessages';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import makeStyles from '@material-ui/core/styles/makeStyles';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import { addLoadFilter, getEquipments, getLoadFilter, updateLoadFilter } from '../../../../redux/actions/Loads';
import AppAutocomplete from '@jumbo/components/Common/formElements/AppAutocomplete';
import { getCities } from '../../../../redux/actions/Cities';
import { ButtonGroup, InputAdornment, MenuItem } from '@material-ui/core';
import Select from 'react-select';
import AppDatePicker from '@jumbo/components/Common/formElements/AppDatePicker';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import CitiesAutocomplete from 'components/common/CitiesAutocomplete';

const useStyles = makeStyles(theme => ({
  dialogRoot: {
    position: 'relative',
  },
  dialogTitleRoot: {
    '& .MuiTypography-h6': {
      fontSize: 16,
      color: theme.palette.common.dark,
    },
  },
  toggleLoadTypeRoot: {
    textAlign: 'center',
  },
  root: { overflow: 'visible'},
}));

// const trailerTypeOptions = [
//   { name: 'Containers' },
//   { name: 'Dry Bulk' },
//   { name: 'Flat Bed' },
//   { name: 'Hazardous Materials' },
//   { name: 'Power Only' },
//   { name: 'Reefers' },
//   { name: 'Tankers' },
//   { name: 'Vans Specialized' },
//   { name: 'Vans Standard' },
//   { name: 'Others' },
// ];

const dhOptions = [
  { name: '50 mi', value: 50 },
  { name: '100 mi', value: 100 },
  { name: '150 mi', value: 150 },
  { name: '200 mi', value: 200 },
];

const AddEditLoadFilter = ({ open, onCloseDialog, setCurrentTab, setPage }) => {
  const classes = useStyles();
  const { currentLoadFilter } = useSelector(({ loadsReducer }) => loadsReducer);
  const equipments = useSelector(state => state.loadsReducer.equipments);
  const [loadType, setLoadType] = useState('Daily');
  const [pickUpValue, setPickUpValue] = useState(null);
  const [dropOffValue, setDropOffValue] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [lengthValue, setLengthValue] = useState(null);
  const [weightValue, setWeightValue] = useState(null);
  const [trailerTypes, setTrailerTypes] = useState([]);
  const [dho, setDho] = useState(null);
  const [dhd, setDhd] = useState(null);
  const [pickUpError, setPickUpError] = useState('');
  const [trailerTypeOptions, setTrailerTypeOptions] = useState([]);

  // const { cities } = useSelector(({ citiesReducer }) => citiesReducer);

  const dispatch = useDispatch();

  useEffect(() => {
    if (equipments && equipments.length) {
      let options = [];
      equipments.map(v => {
        options.push({ value: v, label: v });
      });
      setTrailerTypeOptions(options);
    }
  }, [equipments]);

  useEffect(() => {
    if (currentLoadFilter) {
      setLoadType(currentLoadFilter.loadType);
      setPickUpValue(currentLoadFilter.pickUpValue);
      setDropOffValue(currentLoadFilter.dropOffValue);
      if (currentLoadFilter.startDate) {
        setStartDate(currentLoadFilter.startDate);
      }
      if (currentLoadFilter.endDate) {
        setEndDate(currentLoadFilter.endDate);
      }
      setDho(currentLoadFilter.dho);
      setDhd(currentLoadFilter.dhd);
      setLengthValue(currentLoadFilter.lengthValue);
      setWeightValue(currentLoadFilter.weightValue);
      setTrailerTypes(currentLoadFilter.trailerTypes);
    }
  }, [currentLoadFilter]);

  // useEffect(() => {
  //   if (cities.length === 0) {
  //     dispatch(getCities());
  //   }
  // }, [dispatch]);

  useEffect(() => {
    dispatch(getEquipments())
      .then()
      .catch();
  }, [dispatch]);

  const onSubmitClick = () => {
    if (!pickUpValue) {
      setPickUpError(requiredMessage);
    } else {
      onSave();
    }
  };

  const onSave = () => {
    const loadSearchFilters = {
      loadType,
      pickUpValue,
      dropOffValue,
      startDate,
      endDate,
      dho,
      dhd,
      lengthValue,
      weightValue,
      trailerTypes,
    };

    if (currentLoadFilter) {
      dispatch(
        updateLoadFilter({ ...currentLoadFilter, ...loadSearchFilters }, () => {
          onCloseDialog();
          setCurrentTab(2);
          setPage(0);
        }),
      );
    } else {
      dispatch(
        addLoadFilter(loadSearchFilters, () => {
          onCloseDialog();
          setCurrentTab(2);
          setPage(0);
        }),
      );
    }
  };

  function handleChange(key, value) {
    if (value && !value.match(/^[0-9]*$/g)) {
      return;
    }
    if (key === 'weight' && value && value.length > 5) {
      return;
    }
    if (key === 'length' && value && value.length > 2) {
      return;
    }
    if (key === 'length') {
      setLengthValue(value);
    }
    if (key === 'weight') {
      setWeightValue(value);
    }
  }

  function handleClear() {
    setPickUpValue(null);
    setDropOffValue(null);
    setStartDate(null);
    setEndDate(null);
    setDho(null);
    setDhd(null);
    setLengthValue(null);
    setWeightValue(null);
    setTrailerTypes([]);
  }

  return (
    <Dialog open={open} onClose={onCloseDialog} className={classes.dialogRoot} PaperProps={{ className: classes.root }}>
      <DialogTitle className={classes.dialogTitleRoot}>
        {currentLoadFilter ? 'Edit Search Filter' : 'Add New Filter'}
      </DialogTitle>
      <DialogContent className={classes.root} dividers>
        <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} alignItems="center" mb={{ xs: 6 }}>
          <GridContainer>
            <Grid item xs={12} className={classes.toggleLoadTypeRoot}>
              {/* <ToggleButtonGroup
                color="primary"
                value={loadType}
                exclusive
                onChange={(event, selected) => {
                  setLoadType(selected);
                }}> */}
                {/* <ToggleButton value="Daily" style={{ minWidth: '100px' }}>
                  Daily
                </ToggleButton> */}
                {/* <ToggleButton value="Dedicated" style={{ minWidth: '100px' }}>
                  Dedicated
                </ToggleButton> */}
              {/* </ToggleButtonGroup> */}
            </Grid>
            <Grid item xs={12} sm={6}>
              {/* <AppTextInput
                fullWidth
                variant="outlined"
                label="First name"
                value={firstName}
                onChange={e => {
                  setFirstName(e.target.value);
                  setFirstNameError('');
                }}
                helperText={firstNameError}
              /> */}
              <CitiesAutocomplete
                label="Pick Up"
                value={pickUpValue || ''}
                helperText={pickUpError}
                handleChange={(selected) => {
                  setPickUpValue(selected);
                  setPickUpError('');
                }}
              />
              {/* <AppAutocomplete
                variant="outlined"
                label="Pick Up"
                value={pickUpValue || ''}
                options={cities}
                getOptionLabel={option => (option === '' ? option : option.name)}
                helperText={pickUpError}
                onChange={(event, selected) => {
                  setPickUpValue(selected);
                  setPickUpError('');
                }}
              /> */}
            </Grid>
            <Grid item xs={12} sm={6}>
              <CitiesAutocomplete
                label="Drop Off"
                value={dropOffValue || ''}
                handleChange={(selected) => {
                  setDropOffValue(selected);
                }}
              />
              {/* <AppAutocomplete
                variant="outlined"
                label="Drop Off"
                value={dropOffValue || ''}
                options={cities}
                getOptionLabel={option => (option === '' ? option : option.name)}
                onChange={(event, selected) => {
                  setDropOffValue(selected);
                }}
              /> */}
            </Grid>
          </GridContainer>
        </Box>
        <Box mb={{ xs: 6 }} display="flex">
          <GridContainer>
            <Grid item xs={12} sm={6}>
              <AppSelectBox
                fullWidth
                variant="outlined"
                label="DH-O"
                value={dho || ''}
                onChange={e => {
                  setDho(e.target.value);
                }}
                data={dhOptions}
                labelKey="name"
                valueKey="value"
                disabled={!pickUpValue}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <AppSelectBox
                fullWidth
                variant="outlined"
                label="DH-D"
                value={dhd || ''}
                onChange={e => {
                  setDhd(e.target.value);
                }}
                data={dhOptions}
                labelKey="name"
                valueKey="value"
                disabled={!dropOffValue}
              />
            </Grid>
          </GridContainer>
        </Box>
        <Box mb={{ xs: 6 }} display="flex">
          <GridContainer>
            <Grid item xs={12} sm={6}>
              <AppDatePicker
                autoOk
                id="start-date"
                placeholder="MM/DD/YYYY"
                inputVariant="outlined"
                format="MM/DD/yyyy"
                label="Start Date"
                value={startDate}
                disablePast
                onChange={(event, selected) => {
                  setStartDate(selected);
                  setEndDate(null);
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <AppDatePicker
                autoOk
                id="end-date"
                placeholder="MM/DD/YYYY"
                inputVariant="outlined"
                format="MM/DD/yyyy"
                label="End Date"
                value={endDate}
                disablePast
                minDate={startDate || new Date()}
                onChange={(event, selected) => {
                  setEndDate(selected);
                }}
              />
            </Grid>
          </GridContainer>
        </Box>
        {loadType === 'Daily' ? (
          <Box mb={{ xs: 6 }} display="flex">
            <GridContainer>
              <Grid item xs={12} sm={6}>
                <AppTextInput
                  fullWidth
                  variant="outlined"
                  label="Length"
                  InputProps={{
                    endAdornment: <InputAdornment position="end">ft</InputAdornment>,
                  }}
                  value={lengthValue || ''}
                  onChange={e => handleChange('length', e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <AppTextInput
                  fullWidth
                  variant="outlined"
                  label="Weight"
                  InputProps={{
                    endAdornment: <InputAdornment position="end">lbs</InputAdornment>,
                  }}
                  value={weightValue || ''}
                  onChange={e => handleChange('weight', e.target.value)}
                />
              </Grid>
            </GridContainer>
          </Box>
        ) : (
          ''
        )}
        <Box mb={{ xs: 6 }} display="flex">
          <GridContainer style={{ marginBottom: 12 }}>
            <Grid item xs={12}>
              <Select
                isMulti
                placeholder="Equipment Types"
                options={trailerTypeOptions}
                value={trailerTypes}
                onChange={value => {
                  setTrailerTypes(value);
                }}
                components={{
                  IndicatorSeparator: () => null,
                }}
                fullWidth
              />
            </Grid>
          </GridContainer>
        </Box>
        <Box display="flex" mb={4} position="absolute">
          <Button onClick={handleClear}>Clear</Button>
        </Box>
        <Box display="flex" justifyContent="flex-end" mb={4}>
          <Button onClick={onCloseDialog}>Cancel</Button>
          <Box ml={2}>
            <Button variant="contained" color="primary" onClick={onSubmitClick}>
              Search
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default AddEditLoadFilter;

AddEditLoadFilter.prototype = {
  open: PropTypes.bool.isRequired,
  onCloseDialog: PropTypes.func,
};
